import { PURCHASE_SHIPMENT_SUCCESS, PURCHASE_SHIPMENT_FAILURE, PURCHASE_SHIPMENT_REQUEST, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const PurchaseShipmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case PURCHASE_SHIPMENT_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case PURCHASE_SHIPMENT_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case PURCHASE_SHIPMENT_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default PurchaseShipmentReducer;
